// extracted by mini-css-extract-plugin
export default {"couldNotFindDescription":"NftPage_couldNotFindDescription__Sj+kd"};